// ブラウザ完結版ツールのエントリ。web/app.js（Node 版と共用）へバックエンドを注入し、
// プレビュー用 Service Worker を /preview/ スコープで登録する。
// このモジュールは app.js より先に評価される（index.html で module→defer の順・共に deferred 実行）。
import { backend } from './backend.mjs';
import { ensureSeeded } from './seed.mjs';
import { createAuth, sanitizeReturnHash, isAuthRoute, translateAuthError, validatePassword, validateEmail } from './auth-client.mjs';

ensureSeeded();

// app.js の api() がこれを見つけると fetch せず backend.dispatch へ委譲する（Node 版は未定義＝従来 fetch）。
window.__VN_BROWSER_BACKEND__ = backend;

// ユーザー認証（Supabase Auth）。接続情報がビルドへ注入されている場合のみ有効。
// UI 起動前にセッション復元を完了させ、保護画面が未認証状態で一瞬表示されるのを防ぐ。
const auth = createAuth();
if (auth) {
    window.__VN_AUTH__ = Object.assign(auth, { sanitizeReturnHash, isAuthRoute, translateAuthError, validatePassword, validateEmail });
    try {
        await auth.init();
    } catch (e) {
        console.error('[auth] セッション復元に失敗しました:', e?.message || e);
    }
    // メール確認・OAuth・パスワード再設定リンクからの復帰（?code= / ?error=）。
    // トークン交換は init() 内で完了しているため、URL からパラメータを消し、処理画面へ誘導する
    const params = new URLSearchParams(location.search);
    if (params.has('code') || params.has('error') || params.has('error_description')) {
        window.__VN_AUTH_RETURNED__ = {
            error: params.get('error_description') || params.get('error') || null,
            type: params.get('type') || null,
        };
        history.replaceState(null, '', location.pathname + location.hash);
        if (!location.hash || location.hash === '#' || location.hash === '#/') {
            location.hash = auth.state.passwordRecovery ? '#/reset-password' : '#/auth/callback';
        }
    }
}

// プレビュー仮想ホストの SW（scope=/preview/）。ツール画面自体は制御しない。
if ('serviceWorker' in navigator) {
    navigator.serviceWorker.register('/preview-sw.js', { scope: '/preview/' })
        .catch((e) => console.warn('[preview-sw] 登録に失敗（プレビューはフォールバック表示になります）:', e?.message || e));
}

// バックエンド注入後に UI を起動する。別 script の実行順に依存させず、
// app.js が Node API へ誤接続する競合を防ぐ。i18n（言語決定・辞書・DOM 変換）は UI より先に読み込む。
await import('../web/i18n.js');
await import('../web/app.js');
